import { render, staticRenderFns } from "./statment-report.vue?vue&type=template&id=fd988aae"
import script from "./statment-report.vue?vue&type=script&lang=js"
export * from "./statment-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports